import { render, staticRenderFns } from "./AccreditationWrapper.vue?vue&type=template&id=7d74671a&"
import script from "./AccreditationWrapper.vue?vue&type=script&lang=js&"
export * from "./AccreditationWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports